import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useParams } from "react-router-dom";
import { WorkflowCanvas } from "./components/canvas/WorkflowCanvas.js";
import { WorkflowList } from "./components/workflows/WorkflowList.js";
import { useWorkflow } from "./hooks/useWorkflow.js";
import type { WorkflowState } from "./lib/yaml-serializer.js";

function EditWorkflow() {
	const { id } = useParams<{ id: string }>();
	const { load } = useWorkflow();
	const [state, setState] = useState<WorkflowState | null>(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!id) return;
		load(id).then((s) => {
			setState(s);
			setLoading(false);
		});
	}, [id, load]);

	if (loading) {
		return (
			<div className="flex h-screen items-center justify-center bg-canvas">
				<span className="text-sm text-text-muted">Loading workflow...</span>
			</div>
		);
	}

	return <WorkflowCanvas initialState={state ?? undefined} />;
}

export function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<WorkflowList />} />
				<Route path="/workflows/new" element={<WorkflowCanvas />} />
				<Route path="/workflows/:id" element={<EditWorkflow />} />
			</Routes>
		</BrowserRouter>
	);
}
